import { IconButton } from '@chakra-ui/react';
import { Icon } from '../Icon';

type Props = {
  direction: 'left' | 'right';
  label: string;
  testId: string;
  onClick: () => void;
};

export const CarouselChevron = ({
  direction,
  label,
  testId,
  onClick,
}: Props) => (
  <IconButton
    _focusVisible={{ boxShadow: 'ah-ring-active', outline: 'none' }}
    _hover={{ '& svg': { transform: 'scale(1.5)' } }}
    aria-label={label}
    color="ink.strong"
    data-testid={`${testId}-${direction}`}
    display="flex"
    icon={<Icon icon={direction === 'left' ? 'ChevronLeft' : 'ChevronRight'} />}
    justifyContent={direction === 'left' ? 'flex-start' : 'flex-end'}
    left={direction === 'left' ? 0 : undefined}
    pos="absolute"
    right={direction === 'right' ? 0 : undefined}
    size="sm"
    top="50%"
    transform="translateY(-50%)"
    variant="unstyled"
    zIndex={1}
    sx={{
      '& svg': {
        transformOrigin: 'center',
        transition: 'transform 160ms ease-out',
      },
    }}
    onClick={onClick}
  />
);
